document.addEventListener('click', function (e) {
  var title = e.target.closest('.new-faq-title');
  if (title) {
    var wasActive = title.classList.contains('active');
    document.querySelectorAll('.new-faq-title').forEach(function (t) { t.classList.remove('active'); });
    document.querySelectorAll('.new-faq-text').forEach(function (x) { x.style.display = 'none'; });
    if (!wasActive) { title.classList.add('active'); var txt = title.nextElementSibling; if (txt && txt.classList.contains('new-faq-text')) txt.style.display = 'block'; }
    return;
  }
  var cta = e.target.closest('.new-htu-link, .js-scroll-to-atc');
  if (cta) {
    var href = cta.getAttribute('href') || '';
    if (href.charAt(0) === '#') {
      var target = document.querySelector('product-form-component, form[action*="/cart/add"], .buy-buttons-block') || document.getElementById('MainContent');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
  }
  var btn = e.target.closest('.new-prod-btn');
  if (btn) {
    var item = { id: btn.getAttribute('data-id'), quantity: 1 };
    var sp = btn.getAttribute('data-sp'); if (sp && sp !== 'none') item.selling_plan = sp;
    btn.classList.add('active');
    if (btn.classList.contains('hdc-pair-btn')) hdcTag('pair_add', btn.getAttribute('data-handle') || 'unknown');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' }, body: JSON.stringify({ items: [item], sections: 'cart-drawer,cart-icon-bubble' }) })
      .then(function (r) { return r.json(); }).then(function (res) {
        if (!res.status) {
          if (btn.classList.contains('hdc-pair-btn')) { btn.classList.add('is-added'); btn.textContent = 'Added'; }
          if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); } else { document.dispatchEvent(new CustomEvent('cart:refresh')); }
        }
      })
      .catch(function (err) { console.error('ATC error', err); }).finally(function () { btn.classList.remove('active'); });
  }
});

function hdcTag(name, value) { try { if (typeof window.clarity === 'function') window.clarity('set', name, String(value)); } catch (e) {} }

var HDC_DESC = {
  'bone-broth-powder': 'Joints, digestion & hydration',
  'beef-bone-broth-for-dogs': 'Joints, digestion & hydration',
  'turkey-bone-broth-for-dogs': 'Gentle on sensitive tummies',
  'fish-broth': 'Hydration for cats & dogs',
  'honest-dog-co-goat-milk-powder-for-dogs': 'Gut-friendly hydration & calcium',
  'honest-dog-co-green-lipped-mussel-powder-for-dogs-100-grams-mobility-and-flexibility-hip-and-joint-support': 'Natural joint & mobility support',
  'pumpkin-powder': 'Firmer stools, settled tummies',
  'dental-powder-for-dogs-made-from-natural-seaweed-fights-plaque-and-tartar-clean-teeth-healthy-gums-fresh-breath-made-in-uk-by-honest-dog-co': 'Cleaner teeth, fresher breath',
  'collagen-powder-for-dogs': 'Skin, coat & joint support',
  'super-greens-for-dogs': 'Daily whole-food nutrition',
  'mushrooms-for-dogs': 'Immunity, gut & cognition',
  'honest-dog-co-ultimate-dog-nutrition-bundle': 'Broth, mussel & dental in one',
  'complete-dog-nutrition-bundle-beef-version': 'Broth, mussel & dental in one'
};
/* Products that carry the Bestseller pill next to the rating on mobile */
var HDC_BESTSELLERS = ['bone-broth-powder', 'beef-bone-broth-for-dogs'];
/* Short display names for the mobile topline where the SEO product title is too long (keyed by handle) */
var HDC_SHORT_TITLE = {
  'mushrooms-for-dogs': 'Turkey Tail Mushroom Blend',
  'honest-dog-co-green-lipped-mussel-powder-for-dogs-100-grams-mobility-and-flexibility-hip-and-joint-support': 'Green Lipped Mussel',
  'dental-powder-for-dogs-made-from-natural-seaweed-fights-plaque-and-tartar-clean-teeth-healthy-gums-fresh-breath-made-in-uk-by-honest-dog-co': 'Dental Powder',
  'honest-dog-co-goat-milk-powder-for-dogs': 'Goat Milk Powder',
  'fish-broth': 'Fish Broth for Cats & Dogs'
};
/* Live site-wide Loox totals (window.HDC_REVIEWS, from snippets/hdc-reviews-data.liquid). Falls back to the text typed in the template. */
function hdcReviewFigures(labelText) {
  var live = window.HDC_REVIEWS;
  if (live && live.count > 0) return { score: String(live.avg), count: Number(live.count).toLocaleString('en-GB') };
  var t = labelText || '';
  return { score: (t.match(/(\d\.\d)/) || [])[1], count: (t.match(/by\s+([\d,]+)/) || t.match(/([\d,]{3,})/) || [])[1] };
}

/* Collection cards: one-line description under each title */
(function () {
  function apply() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.hdc-card-desc')) return;
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!m) return;
      var text = HDC_DESC[m[1]]; if (!text) return;
      var titleWrap = card.querySelector('.product-card__content > a.contents') || card.querySelector('.text-block--align-left');
      if (!titleWrap) return;
      var d = document.createElement('div'); d.className = 'hdc-card-desc'; d.textContent = text;
      titleWrap.insertAdjacentElement('afterend', d);
    });
  }
  apply();
  new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
})();

/* PDP "Dog owners also bought" — two subscription rows directly after the Tell Me About card.
   Reads product/plan data from the (visually hidden) Build Their Routine section markup. */
(function () {
  var PREFER = ['pumpkin-powder', 'honest-dog-co-green-lipped-mussel-powder-for-dogs-100-grams-mobility-and-flexibility-hip-and-joint-support', 'honest-dog-co-goat-milk-powder-for-dogs'];
  var SHORT = { 'honest-dog-co-green-lipped-mussel-powder-for-dogs-100-grams-mobility-and-flexibility-hip-and-joint-support': 'Green Lipped Mussel', 'pumpkin-powder': 'Pumpkin Digestive Aid', 'honest-dog-co-goat-milk-powder-for-dogs': 'Goat Milk Powder' };
  var SUB_DISCOUNT = 0.15;
  var money = function (p) { return '£' + p.toFixed(2); };
  var tries = 0;
  (function init() {
    var tma = document.querySelector('.tell-me-about');
    var slides = document.querySelectorAll('.new-prod-slide');
    if (!tma || !slides.length) { if (tries++ < 40) setTimeout(init, 300); return; }
    if (document.querySelector('.hdc-pairs')) return;
    var current = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    var items = [];
    slides.forEach(function (s) {
      var a = s.querySelector('a.new-prod-item'); var b = s.querySelector('.new-prod-btn');
      if (!a || !b || b.classList.contains('sold')) return;
      var h = ((a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/) || [])[1]; if (!h || h === current) return;
      var img = s.querySelector('.new-prod-img'); var t = s.querySelector('.new-prod-title'); var p = s.querySelector('.new-prod-price');
      var otp = parseFloat(((p && p.textContent) || '').replace(/[^0-9.]/g, '')) || 0;
      var sp = b.getAttribute('data-sp'); if (!sp || sp === 'none') return;
      items.push({ handle: h, href: a.getAttribute('href'), img: img && (img.getAttribute('src') || img.getAttribute('data-src')), title: SHORT[h] || (t ? t.textContent.trim() : ''), otp: otp, sub: otp * (1 - SUB_DISCOUNT), id: b.getAttribute('data-id'), sp: sp });
    });
    if (!items.length) return;
    items.sort(function (x, y) { var ix = PREFER.indexOf(x.handle), iy = PREFER.indexOf(y.handle); return (ix < 0 ? 99 : ix) - (iy < 0 ? 99 : iy); });
    var pick = items.slice(0, 2);
    var row = document.createElement('div'); row.className = 'hdc-pairs';
    row.innerHTML = '<div class="hdc-pairs__head">Dog owners also bought</div><div class="hdc-pairs__grid"></div>';
    var grid = row.querySelector('.hdc-pairs__grid');
    pick.forEach(function (it) {
      var el = document.createElement('div'); el.className = 'hdc-pair';
      el.innerHTML = '<a class="hdc-pair__img" href="' + it.href + '">' + (it.img ? '<img src="' + it.img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="hdc-pair__body"><a class="hdc-pair__title" href="' + it.href + '">' + it.title + '</a><div class="hdc-pair__desc">' + (HDC_DESC[it.handle] || '') + '</div>' +
        '<div class="hdc-pair__foot"><span class="hdc-pair__price"><b>' + money(it.sub) + '</b><s>' + money(it.otp) + '</s></span><button type="button" class="new-prod-btn hdc-pair-btn" data-id="' + it.id + '" data-sp="' + it.sp + '" data-handle="' + it.handle + '">+ Add</button></div></div>';
      grid.appendChild(el);
    });
    tma.insertAdjacentElement('afterend', row);
  })();
})();

/* Desktop: rewrite the typed rating line with the live site-wide figure ("Rated 4.7 by 1,084 Pet Parents") */
(function () {
  if (window.innerWidth < 750) return;
  var tries = 0;
  (function init() {
    var label = document.querySelector('.product-details .hdc-rating .hdc-rating__label');
    if (!label) { if (tries++ < 40) setTimeout(init, 250); return; }
    var f = hdcReviewFigures(label.textContent);
    if (window.HDC_REVIEWS && f.score && f.count) { var em = label.querySelector('em') || label; em.textContent = 'Rated ' + f.score + ' by ' + f.count + ' Pet Parents'; }
  })();
})();

/* Mobile topline under the gallery: Title / ★★★★★ 4.7 rating · 1,084 reviews [Bestseller] / strapline */
(function () {
  if (window.innerWidth >= 750) return;
  var tries = 0;
  (function init() {
    if (document.querySelector('.hdc-mobile-topline')) return;
    var rating = document.querySelector('.product-details .hdc-rating');
    if (!rating) { if (tries++ < 40) setTimeout(init, 250); return; }
    var ratingBlock = rating.closest('.custom-liquid, .shopify-block, [class*="custom-liquid"]') || rating.parentElement;
    var strap = null, el = ratingBlock.nextElementSibling;
    while (el) {
      var ps = el.querySelectorAll('p');
      if (ps.length === 1 && (el.matches('rte-formatter, .text-block') || el.querySelector('rte-formatter, .text-block'))) { strap = el; break; }
      if (ps.length > 1) break;
      el = el.nextElementSibling;
    }
    var label = rating.querySelector('.hdc-rating__label');
    if (label) {
      var f = hdcReviewFigures(label.textContent);
      if (f.score && f.count) label.innerHTML = '<span class="hdc-rating__score">' + f.score + ' rating</span><span class="hdc-rating__sep">·</span><span class="hdc-rating__count">' + f.count + ' reviews</span>';
      else if (f.score) label.innerHTML = '<span class="hdc-rating__score">' + f.score + ' rating</span>';
    }
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handle && HDC_BESTSELLERS.indexOf(handle) > -1) { var pill = document.createElement('span'); pill.className = 'hdc-bestseller'; pill.textContent = 'Bestseller'; rating.appendChild(pill); }
    var titleText = (handle && HDC_SHORT_TITLE[handle]) || '';
    if (!titleText) { var st = document.querySelector('.sticky-add-to-cart__title'); if (st) titleText = st.textContent.trim(); }
    if (!titleText) titleText = (document.title.split('–')[0] || '').trim();
    var wrap = document.createElement('div'); wrap.className = 'hdc-mobile-topline';
    ratingBlock.parentElement.insertBefore(wrap, ratingBlock);
    if (titleText) { var h = document.createElement('h1'); h.className = 'hdc-mobile-title'; h.textContent = titleText; wrap.appendChild(h); }
    wrap.appendChild(ratingBlock);
    if (strap) { strap.classList.add('hdc-strap'); wrap.appendChild(strap); }
  })();
})();

/* Mobile buy box tidy */
(function () {
  if (window.innerWidth >= 750) return;
  var tries = 0;
  (function init() {
    var chooser = document.querySelector('.subscription-chooser');
    var block = chooser && chooser.querySelector('.subscription-chooser__subscription-block');
    if (!chooser || !block) { if (tries++ < 40) setTimeout(init, 250); return; }
    if (block.querySelector('.hdc-cancel-note')) return;
    var sub = block.querySelector('.subscription-chooser__subscription-subtitle');
    var freq = block.querySelector('.subscription-chooser__frequency');
    if (sub && freq) { var n = document.createElement('span'); n.className = 'hdc-cancel-note'; n.textContent = sub.textContent.trim(); freq.appendChild(n); sub.classList.add('hdc-hidden'); }
    var titleEl = block.querySelector('.subscription-chooser__subscription-title');
    Array.prototype.forEach.call(block.querySelectorAll('.subscription-chooser__benefit'), function (li) {
      var save = li.querySelector('[data-save-benefit]');
      if (save) { if (titleEl) { save.classList.add('hdc-save-badge'); titleEl.appendChild(save); } li.classList.add('hdc-hidden'); }
      else { li.innerHTML = li.innerHTML.replace(/\s*\((RRP|worth)[^)]*\)/i, ''); }
    });
  })();
})();

/* Tag 1: saw_atc */
(function () {
  var tries = 0;
  (function init() {
    var btn = document.querySelector('.subscription-chooser .add-to-cart-button, product-form-component .add-to-cart-button, form[action*="/cart/add"] button[type="submit"]');
    if (!btn) { if (tries++ < 40) setTimeout(init, 250); return; }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { hdcTag('saw_atc', window.innerWidth < 750 ? 'mobile' : 'desktop'); io.disconnect(); } }); }, { threshold: 0.5 });
    io.observe(btn);
  })();
})();

/* Tag 2: tma_tab */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.tell-me-about__header-item');
  if (tab) hdcTag('tma_tab', tab.getAttribute('data-tab') || (tab.textContent || '').trim().toLowerCase().replace(/\s+/g, '_'));
}, true);

/* Early sticky bar + Tag 3 */
(function () {
  var sticky, mainBtn, forced = false, hasScrolled = false;
  function getMainBtn() { return document.querySelector('.subscription-chooser .add-to-cart-button, product-form-component .add-to-cart-button, form[action*="/cart/add"] button[type="submit"]'); }
  function evaluate() {
    if (!sticky || !mainBtn) return;
    var r = mainBtn.getBoundingClientRect(); var below = r.top > window.innerHeight;
    var available = sticky.getAttribute('data-variant-available') === 'true';
    var shouldForce = below && available && (hasScrolled || window.scrollY > 40);
    if (shouldForce !== forced) { forced = shouldForce; sticky.classList.toggle('hdc-force-stuck', forced); }
  }
  function onStickyClick(e) {
    if (!forced) return;
    var b = e.target.closest('.sticky-add-to-cart__button'); if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation(); hdcTag('sticky_buynow', 'used');
    var chooser = document.querySelector('.subscription-chooser') || mainBtn;
    if (chooser) chooser.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  var tries = 0;
  (function init() {
    sticky = document.querySelector('sticky-add-to-cart'); mainBtn = getMainBtn();
    if (!sticky || !mainBtn) { if (tries++ < 40) setTimeout(init, 250); return; }
    sticky.addEventListener('click', onStickyClick, true);
    window.addEventListener('scroll', function () { hasScrolled = true; evaluate(); }, { passive: true });
    window.addEventListener('resize', evaluate);
    setTimeout(function () { hasScrolled = true; evaluate(); }, 2500); evaluate();
  })();
})();

/* Subscription box prototypes — OFF by default (?hdc_sub=link | cards | off) */
(function () {
  var HDC_SUB_DEFAULT = '';
  var params = new URLSearchParams(location.search);
  try { var p = params.get('hdc_sub'); if (p === 'cards' || p === 'link') sessionStorage.setItem('hdc_sub', p); if (p === 'off') sessionStorage.removeItem('hdc_sub'); } catch (e) {}
  var mode = HDC_SUB_DEFAULT; try { mode = sessionStorage.getItem('hdc_sub') || mode; } catch (e) {}
  if (mode !== 'cards' && mode !== 'link') return;
  var money = function (pence) { return '£' + (pence / 100).toFixed(2); };
  var tries = 0;
  (function init() {
    var chooser = document.querySelector('.subscription-chooser');
    var block = chooser && chooser.querySelector('.subscription-chooser__subscription-block');
    var cb = chooser && chooser.querySelector('.subscription-chooser__toggle-checkbox');
    if (!chooser || !block || !cb) { if (tries++ < 40) setTimeout(init, 250); return; }
    if (chooser.querySelector('.hdc-purchase-cards, .hdc-subfirst')) return;
    var freqLabel = block.querySelector('.subscription-chooser__frequency label'); if (freqLabel) freqLabel.textContent = 'Delivered every';
    function activeOpt() { return chooser.querySelector('.subscription-chooser__quantity-option--active') || chooser.querySelector('.subscription-chooser__quantity-option'); }
    function prices() { var o = activeOpt(); if (!o) return null; var qty = parseInt(o.dataset.quantity || '1', 10) || 1; return { qty: qty, sub: parseInt(o.dataset.priceSub || '0', 10) / qty, otp: parseInt(o.dataset.priceOnetime || '0', 10) / qty, rrp: parseInt(o.dataset.unitRrp || '0', 10) || (parseInt(o.dataset.rrpOnetime || '0', 10) / qty), pct: o.dataset.savePercentSub || '' }; }
    function setMode(on) { if (cb.checked !== on) { cb.checked = on; cb.dispatchEvent(new Event('input', { bubbles: true })); cb.dispatchEvent(new Event('change', { bubbles: true })); } paint(); hdcTag('sub_' + mode, on ? 'sub' : 'otp'); }
    var paint, refresh;
    if (mode === 'link') {
      chooser.classList.add('hdc-has-subfirst');
      var head = document.createElement('div'); head.className = 'hdc-subfirst';
      head.innerHTML = '<span class="hdc-subfirst__title">Subscribe &amp; Save <b class="hdc-subfirst__pct"></b></span><span class="hdc-subfirst__price"><b class="hdc-subfirst__now"></b><s class="hdc-subfirst__was"></s><span class="hdc-subfirst__each"></span></span>';
      block.insertBefore(head, block.firstChild);
      var foot = document.createElement('div'); foot.className = 'hdc-otp-link';
      foot.innerHTML = '<button type="button" class="hdc-otp-link__btn hdc-otp-link__to-otp">Prefer to buy once? <u>One-time purchase for <span class="hdc-otp-link__price"></span></u></button><span class="hdc-otp-link__otp-state">One-time purchase · <b class="hdc-otp-link__price2"></b> &nbsp;<button type="button" class="hdc-otp-link__btn hdc-otp-link__to-sub"><u>Switch to Subscribe &amp; Save <span class="hdc-otp-link__pct"></span> (<span class="hdc-otp-link__subprice"></span>)</u></button></span>';
      block.parentElement.insertBefore(foot, block.nextSibling);
      refresh = function () { var p = prices(); if (!p) return; var e = p.qty > 1 ? ' / pouch' : ''; head.querySelector('.hdc-subfirst__pct').textContent = p.pct ? p.pct + '%' : ''; head.querySelector('.hdc-subfirst__now').textContent = money(p.sub); head.querySelector('.hdc-subfirst__was').textContent = p.rrp > p.sub ? money(p.rrp) : ''; head.querySelector('.hdc-subfirst__each').textContent = e; foot.querySelector('.hdc-otp-link__price').textContent = money(p.otp) + e; foot.querySelector('.hdc-otp-link__price2').textContent = money(p.otp) + e; foot.querySelector('.hdc-otp-link__pct').textContent = p.pct ? p.pct + '%' : ''; foot.querySelector('.hdc-otp-link__subprice').textContent = money(p.sub) + e; };
      paint = function () { chooser.classList.toggle('hdc-mode-otp', !cb.checked); };
      foot.addEventListener('click', function (e) { if (e.target.closest('.hdc-otp-link__to-otp')) setMode(false); if (e.target.closest('.hdc-otp-link__to-sub')) setMode(true); });
    } else {
      var cards = document.createElement('div'); cards.className = 'hdc-purchase-cards';
      cards.innerHTML = '<button type="button" class="hdc-pc hdc-pc--sub" data-mode="sub" aria-pressed="true"><span class="hdc-pc__radio"></span><span class="hdc-pc__body"><span class="hdc-pc__title">Subscribe &amp; Save <b class="hdc-pc__pct"></b></span><span class="hdc-pc__price"><b class="hdc-pc__now"></b> <s class="hdc-pc__was"></s></span></span></button><button type="button" class="hdc-pc hdc-pc--otp" data-mode="otp" aria-pressed="false"><span class="hdc-pc__radio"></span><span class="hdc-pc__body"><span class="hdc-pc__title">One-time</span><span class="hdc-pc__price"><b class="hdc-pc__otp"></b></span></span></button>';
      block.parentElement.insertBefore(cards, block); chooser.classList.add('hdc-has-cards');
      refresh = function () { var p = prices(); if (!p) return; cards.querySelector('.hdc-pc__pct').textContent = p.pct ? p.pct + '%' : ''; cards.querySelector('.hdc-pc__now').textContent = money(p.sub); cards.querySelector('.hdc-pc__was').textContent = p.rrp > p.sub ? money(p.rrp) : ''; cards.querySelector('.hdc-pc__otp').textContent = money(p.otp); cards.querySelectorAll('.hdc-pc__price').forEach(function (x) { x.dataset.suffix = p.qty > 1 ? ' / pouch' : ''; }); };
      paint = function () { cards.querySelector('.hdc-pc--sub').setAttribute('aria-pressed', cb.checked ? 'true' : 'false'); cards.querySelector('.hdc-pc--otp').setAttribute('aria-pressed', cb.checked ? 'false' : 'true'); chooser.classList.toggle('hdc-mode-otp', !cb.checked); };
      cards.addEventListener('click', function (e) { var c = e.target.closest('.hdc-pc'); if (c) setMode(c.dataset.mode === 'sub'); });
    }
    cb.addEventListener('change', paint);
    chooser.addEventListener('click', function (e) { if (e.target.closest('.subscription-chooser__quantity-option')) setTimeout(refresh, 120); });
    refresh(); paint();
  })();
})();